// /services/indexedDB.js
  const DB_NAME = 'myDatabase';
  const DB_VERSION = 7; // v7: added fileHandles store for FSA resume

  const openDatabase = async() => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains('images')) {
        db.createObjectStore('images', { keyPath: 'id', autoIncrement: true });
      } 
      if (!db.objectStoreNames.contains('folders')) {
        db.createObjectStore('folders', { keyPath: 'id', autoIncrement: true });
      }
      if (!db.objectStoreNames.contains('data')) {
        db.createObjectStore('data', { keyPath: 'id', autoIncrement: true });
      }
      if (!db.objectStoreNames.contains('originalData')) {
        db.createObjectStore('originalData', { keyPath: 'id', autoIncrement: true });
      }
      if (!db.objectStoreNames.contains('uploads')) {
        db.createObjectStore('uploads', { keyPath: 'id', autoIncrement: true });
      }
      if (!db.objectStoreNames.contains('fileHandles')) {
        db.createObjectStore('fileHandles', { keyPath: '__key' });
      }
    };

    request.onsuccess = (event) => {
    };
  
    request.onerror = (event) => {
    };
  };
  




  const createFolderWithEmptyImages = (folderId, folderName, eventId = null, userId = null, parentFolderId = null, isVirtual = false, tag = null) => {
    return new Promise( (resolve, reject) => {
      
      // If no folderId is provided, generate one
      if (!folderId) {
        folderId = 'folder_' + new Date().getTime();
      }
      
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('images')) {
          db.createObjectStore('images', { keyPath: 'id', autoIncrement: true });
        } 
        if (!db.objectStoreNames.contains('folders')) {
          db.createObjectStore('folders', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('data')) {
          db.createObjectStore('data', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('originalData')) {
          db.createObjectStore('originalData', { keyPath: 'id', autoIncrement: true });
        }
      };

      request.onsuccess = (event) => {
        const db = event.target.result;
        
        try {
          const transaction = db.transaction(["folders", "data"], "readwrite");
          const folderStore = transaction.objectStore("folders");
          const dataStore = transaction.objectStore("data");
        
            // Step 1: Create a new folder with an empty images array
          const newFolder = {
            folderId: folderId,
            folderName: folderName,
            images: [],
            originalImages: [], // Empty images collection
            eventId: eventId, // Store event ID for context
            userId: userId, // Store user ID for context
            parentFolderId: parentFolderId, // Store parent folder ID for hierarchy
            isSubfolder: !!parentFolderId, // Flag indicating if this is a subfolder
            isVirtual: isVirtual, // Flag indicating if this is a virtual view-only folder
            hasBeenUsedForUpload: false, // Track if folder has been used for uploads
            uploadCompleted: false, // Track if upload process is completed,
            type: folderId.includes('/segregated') ? 'segregated' :
                  folderId.includes('/duplicate') ? 'duplicate' : null,
            tag: tag
          };          // Step 2: Add the folder to both object stores
          
          // Add to folders store
          const folderAddRequest = folderStore.add(newFolder);
          
          // Add to data store for compatibility
          const keyValue = { id: folderId, value: newFolder };
          const dataAddRequest = dataStore.add(keyValue);
        
          folderAddRequest.onsuccess = () => {
            dataAddRequest.onsuccess = () => {
              resolve(newFolder);
            };
            dataAddRequest.onerror = (event) => {
              reject(new Error(`Failed to add folder to data store: ${event.target.error?.message || 'Unknown error'}`));
            };
          };
        
          folderAddRequest.onerror = (event) => {
            reject(new Error(`Failed to add folder to folders store: ${event.target.error?.message || 'Unknown error'}`));
          };

          transaction.onerror = (event) => {
            reject(new Error(`Transaction failed: ${event.target.error?.message || 'Unknown transaction error'}`));
          };

          transaction.oncomplete = () => {
          };
        } catch (error) {
          reject(new Error(`Database transaction setup failed: ${error.message}`));
        }
      };

      request.onerror = (event) => {
        reject(new Error(`Failed to open database: ${event.target.error?.message || 'Unknown database error'}`));
      };
    })
  };
  
  


  






  // Store pending uploads in IndexedDB for offline persistence
  const storePendingUploads = async (uploadData) => {
    return new Promise(async (resolve, reject) => {
      try {
        // Convert File objects to storable format
        
        const filesData = await Promise.all(
          uploadData.files.map(async (file) => ({
            name: file.name,
            size: file.size,
            type: file.type,
            lastModified: file.lastModified,
            blob: file // Store the file as a blob
          }))
        );
        

        // Upsert by composite key to avoid multiple partial records
        const compositeKey = `pu_${uploadData.folderId}_${uploadData.eventId}_${uploadData.userId}`;
        const storableData = {
          ...uploadData,
          // Write both keys so we upsert regardless of existing keyPath ('id' legacy or '__key' new)
          __key: compositeKey,
          id: compositeKey,
          files: filesData
        };

        const request = indexedDB.open(DB_NAME, DB_VERSION);

        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          if (!db.objectStoreNames.contains('images')) {
            db.createObjectStore('images', { keyPath: 'id', autoIncrement: true });
          } 
          if (!db.objectStoreNames.contains('folders')) {
            db.createObjectStore('folders', { keyPath: 'id', autoIncrement: true });
          }
          if (!db.objectStoreNames.contains('data')) {
            db.createObjectStore('data', { keyPath: 'id', autoIncrement: true });
          }
          if (!db.objectStoreNames.contains('originalData')) {
            db.createObjectStore('originalData', { keyPath: 'id', autoIncrement: true });
          }
          if (!db.objectStoreNames.contains('pendingUploads')) {
            // New installs: prefer '__key'. Existing DBs may still use 'id'.
            db.createObjectStore('pendingUploads', { keyPath: '__key' });
          }
        };

        request.onsuccess = (event) => {
          const db = event.target.result;
          const transaction = db.transaction('pendingUploads', 'readwrite');
          const store = transaction.objectStore('pendingUploads');
          const addRequest = store.put(storableData);

          addRequest.onsuccess = () => {
            resolve();
          };

          addRequest.onerror = (event) => {
            reject(event);
          };
        };

        request.onerror = (event) => {
          reject(event);
        };
      } catch (error) {
        reject(error);
      }
    });
  };

  // Retrieve pending uploads from IndexedDB
  const getPendingUploads = async () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('images')) {
          db.createObjectStore('images', { keyPath: 'id', autoIncrement: true });
        } 
        if (!db.objectStoreNames.contains('folders')) {
          db.createObjectStore('folders', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('data')) {
          db.createObjectStore('data', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('uploads')) {
          db.createObjectStore('uploads', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('originalData')) {
          db.createObjectStore('originalData', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('pendingUploads')) {
          db.createObjectStore('pendingUploads', { keyPath: 'id', autoIncrement: true });
        }
      };

      request.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction('pendingUploads', 'readonly');
        const store = transaction.objectStore('pendingUploads');
        const getAllRequest = store.getAll();

        getAllRequest.onsuccess = () => {
          
          // Reconstruct File objects from stored blob data
          const reconstructedUploads = getAllRequest.result.map(uploadData => {
            if (uploadData.files && uploadData.files.length > 0) {
              
              const reconstructedFiles = uploadData.files.map(fileData => {
                return new File([fileData.blob], fileData.name, {
                  type: fileData.type,
                  lastModified: fileData.lastModified
                });
              });
              
              
              return {
                ...uploadData,
                files: reconstructedFiles
              };
            }
            return uploadData;
          });
          
          resolve(reconstructedUploads);
        };

        getAllRequest.onerror = (event) => {
          reject(event);
        };
      };

      request.onerror = (event) => {
        reject(event);
      };
    });
  };

  // Lightweight read: returns pending upload metadata WITHOUT reconstructing File blobs.
  // Use this on mount to avoid loading large binary data into memory.
  const getPendingUploadsMetadata = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);
      request.onsuccess = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('pendingUploads')) {
          resolve([]);
          return;
        }
        const transaction = db.transaction('pendingUploads', 'readonly');
        const store = transaction.objectStore('pendingUploads');
        const getAllRequest = store.getAll();
        getAllRequest.onsuccess = () => {
          const metadata = getAllRequest.result.map(uploadData => ({
            folderId: uploadData.folderId,
            eventId: uploadData.eventId,
            userId: uploadData.userId,
            fileCount: uploadData.files?.length || 0,
            currentIndex: uploadData.currentIndex || 0,
            uploadStatuses: uploadData.uploadStatuses || {},
            timestamp: uploadData.timestamp,
          }));
          resolve(metadata);
        };
        getAllRequest.onerror = (e) => reject(e);
      };
      request.onerror = (e) => reject(e);
    });
  };

  // Clear pending uploads from IndexedDB
  const clearPendingUploads = async () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('images')) {
          db.createObjectStore('images', { keyPath: 'id', autoIncrement: true });
        } 
        if (!db.objectStoreNames.contains('folders')) {
          db.createObjectStore('folders', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('data')) {
          db.createObjectStore('data', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('uploads')) {
          db.createObjectStore('uploads', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('originalData')) {
          db.createObjectStore('originalData', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('pendingUploads')) {
          db.createObjectStore('pendingUploads', { keyPath: 'id', autoIncrement: true });
        }
      };

      request.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction('pendingUploads', 'readwrite');
        const store = transaction.objectStore('pendingUploads');
        const clearRequest = store.clear();

        clearRequest.onsuccess = () => {
          resolve();
        };

        clearRequest.onerror = (event) => {
          reject(event);
        };
      };

      request.onerror = (event) => {
        reject(event);
      };
    });
  };
  



const getAllFolders = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains('images')) {
        db.createObjectStore('images', { keyPath: 'id', autoIncrement: true });
      } 
      if (!db.objectStoreNames.contains('folders')) {
        db.createObjectStore('folders', { keyPath: 'id', autoIncrement: true });
      }
      if (!db.objectStoreNames.contains('data')) {
        db.createObjectStore('data', { keyPath: 'id', autoIncrement: true });
      }
      if (!db.objectStoreNames.contains('originalData')) {
        db.createObjectStore('originalData', { keyPath: 'id', autoIncrement: true });
      }
    };

    request.onerror = (event) => {
      reject(event);
    };

    request.onsuccess = (event) => {
      const db = event.target.result;
      // Determine which object stores actually exist in this DB instance
      const availableStores = [];
      if (db.objectStoreNames.contains('folders')) availableStores.push('folders');
      if (db.objectStoreNames.contains('data')) availableStores.push('data');

      if (availableStores.length === 0) {
        resolve([]);
        return;
      }

      const transaction = db.transaction(availableStores, 'readonly');
      const requests = [];

      if (availableStores.includes('folders')) {
        const folderReq = transaction.objectStore('folders').getAll();
        requests.push(new Promise((res, rej) => {
          folderReq.onsuccess = () => res({ store: 'folders', result: folderReq.result });
          folderReq.onerror = () => rej(folderReq.error);
        }));
      }

      if (availableStores.includes('data')) {
        const dataReq = transaction.objectStore('data').getAll();
        requests.push(new Promise((res, rej) => {
          dataReq.onsuccess = () => res({ store: 'data', result: dataReq.result });
          dataReq.onerror = () => rej(dataReq.error);
        }));
      }

      Promise.all(requests)
        .then(results => {
          const normalized = [];
          results.forEach(({ store, result }) => {
            if (store === 'folders') {
              (result || []).forEach(f => {
                const folderId = f.folderId || f.id || (f.value && f.value.folderId) || null;
                normalized.push({ id: folderId || String(Math.random()), value: f });
              });
            } else if (store === 'data') {
              (result || []).forEach(d => {
                const id = d.id || (d.value && d.value.folderId) || null;
                const value = d.value || d;
                normalized.push({ id: id || String(Math.random()), value });
              });
            }
          });

          // Deduplicate by id
          const seen = new Set();
          const combined = [];
          normalized.forEach(item => {
            const key = item.id || (item.value && (item.value.folderId || item.value.id));
            if (!seen.has(key)) {
              seen.add(key);
              combined.push(item);
            }
          });

          resolve(combined);
        })
        .catch(err => {
          reject(err);
        });
    };

    request.onerror = (event) => {
      reject(event.target.error); // Reject the promise if the database fails to open
    };
  });
};


  const getPendingUploadsFromIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('uploads')) {
          db.createObjectStore('uploads', { keyPath: 'id', autoIncrement: true });
        }
      };

      request.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction('uploads', 'readonly');
        const store = transaction.objectStore('uploads');
        const getAllRequest = store.getAll();

        getAllRequest.onsuccess = () => {
          const allUploads = getAllRequest.result;
          const pendingUploads = allUploads.filter(upload => upload.status === 'pending');
          resolve(pendingUploads);
        };

        getAllRequest.onerror = (event) => {
          reject(event.target.error);
        };
      };

      request.onerror = (event) => {
        reject(event.target.error);
      };
    });
  };



  // Mark folder as having been used for uploads
  const markFolderAsUsedForUpload = (folderId) => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('images')) {
          db.createObjectStore('images', { keyPath: 'id', autoIncrement: true });
        } 
        if (!db.objectStoreNames.contains('folders')) {
          db.createObjectStore('folders', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('data')) {
          db.createObjectStore('data', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('uploads')) {
          db.createObjectStore('uploads', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('originalData')) {
          db.createObjectStore('originalData', { keyPath: 'id', autoIncrement: true });
        }
      };

      request.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction('data', 'readwrite');
        const store = transaction.objectStore('data');
        
        const getRequest = store.get(folderId);
        
        getRequest.onsuccess = () => {
          const folder = getRequest.result;
          if (folder) {
            folder.value.hasBeenUsedForUpload = true;
            folder.value.uploadCompleted = true;
            
            const updateRequest = store.put(folder);
            
            updateRequest.onsuccess = () => {
              resolve();
            };
            
            updateRequest.onerror = (event) => {
              reject(event.target.error);
            };
          } else {
            reject(new Error('Folder not found'));
          }
        };
        
        getRequest.onerror = (event) => {
          reject(event.target.error);
        };
      };

      request.onerror = (event) => {
        reject(event.target.error);
      };
    });
  };

  // Check if folder has been used for uploads
  const isFolderUsedForUpload = (folderId) => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('images')) {
          db.createObjectStore('images', { keyPath: 'id', autoIncrement: true });
        } 
        if (!db.objectStoreNames.contains('folders')) {
          db.createObjectStore('folders', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('data')) {
          db.createObjectStore('data', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('uploads')) {
          db.createObjectStore('uploads', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('originalData')) {
          db.createObjectStore('originalData', { keyPath: 'id', autoIncrement: true });
        }
      };

      request.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction('data', 'readonly');
        const store = transaction.objectStore('data');
        
        const getRequest = store.get(folderId);
        
        getRequest.onsuccess = () => {
          const folder = getRequest.result;
          if (folder) {
            resolve(folder.value.hasBeenUsedForUpload || false);
          } else {
            resolve(false); // Folder not found, assume not used
          }
        };
        
        getRequest.onerror = (event) => {
          resolve(false); // On error, assume not used
        };
      };

      request.onerror = (event) => {
        resolve(false); // On error, assume not used
      };
    });
  };

  // Clear all folders from the database
  const clearAllFolders = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('images')) {
          db.createObjectStore('images', { keyPath: 'id', autoIncrement: true });
        } 
        if (!db.objectStoreNames.contains('folders')) {
          db.createObjectStore('folders', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('data')) {
          db.createObjectStore('data', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('uploads')) {
          db.createObjectStore('uploads', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('originalData')) {
          db.createObjectStore('originalData', { keyPath: 'id', autoIncrement: true });
        }
      };

      request.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction('data', 'readwrite');
        const store = transaction.objectStore('data');
        const clearRequest = store.clear();

        clearRequest.onsuccess = () => {
          resolve();
        };

        clearRequest.onerror = (event) => {
          reject(event.target.error);
        };
      };

      request.onerror = (event) => {
        reject(event.target.error);
      };
    });
  };

  const getFolderById = (folderId) => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);
      request.onerror = (e) => reject(e.target.error);
      request.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction('data', 'readonly');
        const store = transaction.objectStore('data');
        const getRequest = store.get(folderId);
        getRequest.onsuccess = () => resolve(getRequest.result?.value || null);
        getRequest.onerror = (e) => reject(e.target.error);
      };
    });
  };

  const storeFileHandles = async ({ folderId, eventId, userId, handles, currentIndex, uploadStatuses }) => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('fileHandles')) {
          db.createObjectStore('fileHandles', { keyPath: '__key' });
        }
      };
      request.onsuccess = (event) => {
        const db = event.target.result;
        const tx = db.transaction('fileHandles', 'readwrite');
        const store = tx.objectStore('fileHandles');
        const key = `fh_${folderId}_${eventId}_${userId}`;
        store.put({ __key: key, folderId, eventId, userId, handles, currentIndex: currentIndex || 0, uploadStatuses: uploadStatuses || {}, timestamp: new Date().toISOString() });
        tx.oncomplete = () => resolve();
        tx.onerror = (e) => reject(e.target.error);
      };
      request.onerror = (e) => reject(e.target.error);
    });
  };

  const getFileHandles = async (folderId, eventId, userId) => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('fileHandles')) {
          db.createObjectStore('fileHandles', { keyPath: '__key' });
        }
      };
      request.onsuccess = (event) => {
        const db = event.target.result;
        const tx = db.transaction('fileHandles', 'readonly');
        const store = tx.objectStore('fileHandles');
        const key = `fh_${folderId}_${eventId}_${userId}`;
        const getReq = store.get(key);
        getReq.onsuccess = () => resolve(getReq.result || null);
        getReq.onerror = (e) => reject(e.target.error);
      };
      request.onerror = (e) => reject(e.target.error);
    });
  };

  const clearFileHandles = async (folderId, eventId, userId) => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('fileHandles')) {
          db.createObjectStore('fileHandles', { keyPath: '__key' });
        }
      };
      request.onsuccess = (event) => {
        const db = event.target.result;
        const tx = db.transaction('fileHandles', 'readwrite');
        const store = tx.objectStore('fileHandles');
        const key = `fh_${folderId}_${eventId}_${userId}`;
        store.delete(key);
        tx.oncomplete = () => resolve();
        tx.onerror = (e) => reject(e.target.error);
      };
      request.onerror = (e) => reject(e.target.error);
    });
  };

  export {
    openDatabase,
    getAllFolders,
    createFolderWithEmptyImages,
    storePendingUploads,
    getPendingUploads,
    getPendingUploadsMetadata,
    clearPendingUploads,
    getPendingUploadsFromIndexedDB,
    markFolderAsUsedForUpload,
    isFolderUsedForUpload,
    clearAllFolders,
    getFolderById,
    storeFileHandles,
    getFileHandles,
    clearFileHandles
  };
  